import styled from 'react-emotion';
import { Card } from 'bloomer';

const CustomCard = styled(Card)`
  padding: 20px;
  margin: 10px;
  background: #ebf1f5;
`;

export default CustomCard;



// WEBPACK FOOTER //
// ./src/elements/Card.tsx